function initMobileMenu(){
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('body').toggleClass('mobi-menu-open')
        $(this).toggleClass('is-active')
    })

    const menuElm = "#main-navbar-wrapper-mobile";
    const menu = new Mmenu(
        menuElm,
        {
            'offCanvas': {
                'position': 'left-front'
            },
            'navbars': [
                {
                    'position': 'top',
                    'content': [
                        'close'
                    ],
                }
            ],
            'theme': 'white'
        },
        {
            'language': 'de',
        }
    );
    const api = menu.API;
    document.querySelector( ".n-burger" )
        .addEventListener(
            "click", () => {
                api.open();
            }
        );

}